webpackJsonp([53237653772179],{

/***/ 1384:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"Veteran Tech Summit: A Recap of Washington’s Inaugural Veteran and Technology Event","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/veterans-in-tech-summit-a-recap-of-washingtons-inaugural-veteran-and-technology-event","createdAt":"2017-09-22T18:03:05.985Z","blogAuthor":{"fields":{"name":"Lizzie Tao","slug":"blog/author/lizzie-tao"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/3CVZ1xyyCI8yO40wSc0omI/790e438b71ff4ad13bed87961291f2a4/blog-post-blog-veterans-in-tech-summit-a-recap-of-washingtons-inaugural-veteran-and-technology-event.jpg"}}}}}]},"authorJson":{"name":"Lizzie Tao","slug":"blog/author/lizzie-tao","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/lizzie-tao"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-lizzie-tao-936ca145a313288e9c14.js